/**
 * @generated SignedSource<<5f4206346bc7d8dfb92319b068f6baf5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateBuildDialog_pipeline$data = {
  readonly defaultBranch: string | null;
  readonly organization: {
    readonly slug: string;
  };
  readonly pipelineTemplate: {
    readonly uuid: string;
  } | null;
  readonly slug: string;
  readonly " $fragmentType": "CreateBuildDialog_pipeline";
};
export type CreateBuildDialog_pipeline$key = {
  readonly " $data"?: CreateBuildDialog_pipeline$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateBuildDialog_pipeline">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateBuildDialog_pipeline",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultBranch",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PipelineTemplate",
      "kind": "LinkedField",
      "name": "pipelineTemplate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uuid",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};
})();

(node as any).hash = "e24893209c976bc38a430385040e7bdc";

export default node;
